import { requestDialog } from './requestDialog';
import type { FolderDeleteConfirmDialogRequest } from '@mimir/web/dialogs/folderDeleteConfirmDialogRequest';

export function showFolderDeleteConfirmDialog(req: FolderDeleteConfirmDialogRequest) {
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/DeleteFolderConfirmDialog.vue'));
}
